(ns rlws.iot-cloud.frontend.logging
  (:require [re-frame.core :as rf]
            [akiroz.re-frame.storage :as storage]
            ["cloudwatch-front-logger" :refer [Logger]]))

(rf/reg-fx
 ::start-aws-logger
 (fn [[access-key-id secret-access-key region log-group-name]]
   (when (and (not-empty region) (not-empty log-group-name))
     (let [_ (. js/localStorage removeItem "CloudWatchFrontLogger:logStreamName")
           logger (new Logger access-key-id secret-access-key region log-group-name)
           _ (. logger install
                (clj->js {:logStreamNameResolver #(new js/Promise (fn [resolve] (->
                                                                                (storage/<-store "rlws-cloud")
                                                                                :username
                                                                                resolve)))}))]
       (when-not logger
         (prn "Logger not started with access-key-id " access-key-id))))))


;; TODO Remove this effect
;; This call is needed because `cloudwatch-front-logger` treats localStorage as
;; a cache. Invalidating the cache forces the promise defined above under
;; `:logStreamNameResolver` to be resolved, thus picking up a new value for
;; the log stream name which corresponds to the curren logged-in user
(rf/reg-fx
 ::update-log-stream-name
 (fn [_]
   (. js/localStorage removeItem "CloudWatchFrontLogger:logStreamName")))
